"use client"
import React from 'react'
import Navbar from '../../components/admin/common/Navbar'
import MainClientHistory from '../../components/admin/ClientHistory/MainClientHistory'

const clientHistory = () => {

  return (
    <div className="min-h-screen">
    <Navbar />
    <main className="p-4 md:p-10">
    <MainClientHistory/>
    </main>
  </div>
  )
}

export default clientHistory
